module.exports = __webpack_public_path__ + "static/media/facebook2.97feede2.svg";